import { ReceiptAlertTypeFilter } from '@synergy/components';

import { DocumentStatusFilter } from '../../../common/components/filter/document-status-filter';
import { LegacySupplierFilter } from '../../../common/components/filter/legacy-supplier-filter';
import { PaloFilterPanel } from '../../../common/components/palo/palo-filter-panel';
import { RecipientAccountFilter } from '../../../common/components/filter/recipient-account-filter';
import { RecipientContactFilter } from '../../../common/components/filter/recipient-contact-filter';
import { ResponsibleContactFilter } from '../../../common/components/filter/responsible-contact-filter';

/**
 * PALO filter for this list.
 *
 * The rows above come from the list itself and cover every field it declared,
 * each with its own comparison. What stays here are the ones that look a
 * record up by name and hand over its id, which no generic control can do.
 *
 * Gone with the rows: the invoice-date range, which the declared `invoiceDate`
 * now offers with `ab`, `bis` and `zwischen` — offering the same filter twice
 * is what made the toolbar confusing before (#2184). The status filter is back:
 * the sub-views of the navigation set it as a shortcut, and here it shows
 * and changes it, several statuses at once (GF 30.10.2026, #2340).
 */
export const PaloInvoiceOverviewFilter = () => (
    <PaloFilterPanel listKey="invoices">
        <DocumentStatusFilter list="invoices" />
        <ResponsibleContactFilter />
        <RecipientAccountFilter />
        <RecipientContactFilter />
        <LegacySupplierFilter />
        <ReceiptAlertTypeFilter />
    </PaloFilterPanel>
);
